import React, { memo } from "react"
import { Paragraph, ParagraphProps } from "./Paragraph"

export interface HighlightedParagraphProps extends ParagraphProps {
	text: string | null
	highlightedText: string | null
}

export const HighlightedParagraph: React.FC<HighlightedParagraphProps> = memo(
	({ text, highlightedText, ...rest }) => {
		const escapeRegExp = (s: string) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
		const search = highlightedText?.trim() || ""
		const parts: (string | null)[] =
			search ? (text?.split(new RegExp(`(${escapeRegExp(search)})`, "ig")) ?? []) : [text]

		return (
			<Paragraph {...rest}>
				{parts.map((part, idx: number) =>
					part?.toLowerCase() === search.toLowerCase() ?
						<strong key={idx}>{part}</strong>
					:	part
				)}
			</Paragraph>
		)
	}
)

HighlightedParagraph.displayName = "HighlightedParagraph"
